import React from "react";
import PropTypes from "prop-types";



const TasksFilter = ({ filter='All', onFilterChange }) => {
  const buttons = [ 
    { name: 'All', label: 'All'},
    { name: 'Active', label: 'Active'},
    { name: 'Completed', label: 'Completed'},
  ]


  return (
    <ul className="filters">
        <li>
    <button className={filter == 'All' ? 'selected' : ''} type="button" onClick={()=> onFilterChange('All')}>
      {buttons[0].label}
    </button>
  </li>
  <li>
    <button className={filter == 'Active' ? 'selected' : ''} type="button" onClick={()=> onFilterChange('Active')}>
    {buttons[1].label}
    </button>
  </li>
  <li>
    <button className={filter == 'Completed' ? 'selected' : ''} type="button" onClick={()=> onFilterChange('Completed')}>
    {buttons[2].label}
    </button>
  </li>
  </ul>
  )
};

TasksFilter.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
};

export default TasksFilter;